module.exports = __webpack_public_path__ + "static/media/arr_prev.65fcd01f.svg";